import { useCallback } from 'react';

export function useIframeMessaging(iframeRef) {
  const postPrefill = useCallback((payload) => {
    const node = iframeRef.current;
    if (!node || !payload) return;
    try {
      node.contentWindow?.postMessage({ type: 'DIGISCORE_PREFILL', payload }, '*');
    } catch (e) {
      console.error('[SurveyStart] postMessage error:', e);
    }
  }, [iframeRef]);

  const onLoadOnce = useCallback((cb) => {
    const node = iframeRef.current;
    if (!node) return () => {};
    const handler = () => cb?.();
    node.addEventListener('load', handler);
    return () => node.removeEventListener('load', handler);
  }, [iframeRef]);

  return { postPrefill, onLoadOnce };
}